import { Result } from '@cplug/frontend-core/utils'
import type { ActiveResearchCustomer } from '../models/ActiveResearchCustomer'
import {
  ActiveResearchCustomerResponseDTO,
  mapActiveResearchToSubmitPayload,
  mapDTOToActiveResearchCustomer,
  type ActiveResearchCustomerDTO
} from './DTOs/ActiveResearchCustomerDTO'
import { CPBaseGateway } from '~/shared/gateways'

export class CPResearchCustomerGateway extends CPBaseGateway {
  protected apiUrlDomain = 'research-customers/active'

  async getActive (): Promise<Result<ActiveResearchCustomer>> {
    const response = await this.get<{ data: ActiveResearchCustomerDTO }>(this.apiUrlDomain)

    return this.parseResponse(
      response,
      ActiveResearchCustomerResponseDTO,
      dto => Result.ofValue(mapDTOToActiveResearchCustomer(dto.data))
    )
  }

  async updateActive (input: {
    researchId: number
    researchCustomerId?: number
  }): Promise<Result<ActiveResearchCustomer>> {
    const body = mapActiveResearchToSubmitPayload(input)
    const response = await this.put<{ data: ActiveResearchCustomerDTO }>(this.apiUrlDomain, body)

    return this.parseResponse(
      response,
      ActiveResearchCustomerResponseDTO,
      dto => Result.ofValue(mapDTOToActiveResearchCustomer(dto.data))
    )
  }
}
